<script setup>
import { success } from "./helper/import";
</script>
<template>
  <div class="success">
    <img class="icon" :src="success" />
    <div class="text">兑换成功</div>
  </div>
</template>
<style scoped lang="scss">
.success {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .icon {
    width: 48px;
    margin: 0 auto;
    margin-top: 40px;
  }

  .text {
    font-weight: 700;
    font-size: 16px;
    color: #000000;
    margin: 0 auto;
    margin-top: 20px;
  }
}
</style>
